import Axios from '../axios-instance';

const CheckingAccountAPI = {
  getAccountStatement: body => {
    return Axios.post('/AccountStatement/Get', body).then(({ data }) => data);
  },
  getPendingBills: cuit => {
    return Axios.get(`/PendingInvoices/${cuit}`).then(({ data }) => data);
  },
  getSummary: cuit => {
    return Axios.get(`/AccountStatement/GetTotals/${cuit}`).then(({ data }) => data);
  },
  getExcel: body => {
    return Axios.post('/AccountStatement/GetExcel', body, { responseType: 'arraybuffer' }).then(({ data }) => data);
  },
};

export default CheckingAccountAPI;
